const zhCN = {
  'meta.title': '豆趣拼豆｜把喜欢的图片变成拼豆图纸',
  'meta.description': '上传图片，一键生成带色号和用量统计的拼豆图纸。图片只在你的浏览器里处理。',
  'meta.ogTitle': '豆趣拼豆｜把喜欢的图片变成拼豆图纸',
  'meta.ogDescription': '自动配色、数好豆子，生成可打印的拼豆图纸。',
  'meta.ogLocale': 'zh_CN',
  'meta.schemaName': '豆趣拼豆',
  'meta.schemaDescription': '在线拼豆图纸生成工具，把图片变成可编辑、可打印的拼豆图纸。',

  'app.heading': '豆趣拼豆：图片转拼豆图案',
  'app.skipCanvas': '跳到图纸画布',
  'brand.aria': '豆趣拼豆',
  'brand.name': '豆趣拼豆',
  'brand.tagline': '图片转拼豆 · 图纸 · 商城原型',
  'language.label': '界面语言',
  'language.chinese': '中文',
  'language.english': 'EN',
  'language.japanese': '日文',
  'language.korean': '韩文',
  'language.french': '法文',
  'project.untitled': '未命名图纸',
  'project.localOnly': '图片仅在当前浏览器中处理',
  'project.imageLocal': '{width} × {height} · 图片仅在本机处理',

  'action.chooseImage': '选择图片',
  'action.trySample': '用一张图试试',
  'action.downloadOffline': '保存到桌面',
  'action.exportPattern': '导出图纸',
  'action.exportBuildSheet': '导出制作图纸',
  'action.adjust': '调整参数',
  'action.restoreFullImage': '恢复完整原图边界',
  'action.applyRecommended': '使用建议尺寸',
  'action.cropRegion': '裁剪单个区域',
  'action.regenerate': '按当前设置重新生成',
  'action.applySize': '应用尺寸',
  'action.saveProject': '保存图纸，下次接着改',
  'action.loadProject': '打开保存的图纸',
  'action.exportPng': '下载带色号的图纸',
  'action.print': '分页 / 浏览器打印',
  'action.restoreDraft': '恢复上次未完成图纸',
  'action.clearDraft': '清除恢复记录',
  'action.cancel': '取消',
  'action.close': '关闭',
  'action.ok': '我知道了',
  'action.resetCrop': '重置为整图',
  'action.applyCrop': '应用并重新转换',
  'action.cancelConversion': '取消本次转换',
  'action.share': '分享',
  'action.copyLink': '复制链接',
  'action.exportShareCard': '导出宣传图',
  'action.startMaking': '开始制作',
  'action.exportCsv': '导出购豆清单',
  'action.markColorDone': '标记该色完成',
  'action.markColorUndone': '恢复该颜色',
  'action.showAllColors': '显示全部',
  'action.resetMaking': '重置进度',
  'action.star': '收藏本站',
  'action.reportIssue': '意见反馈',
  'action.contribute': '使用帮助',

  'aria.help': '使用说明',
  'aria.undo': '撤销',
  'aria.redo': '重做',
  'aria.zoom': '画布缩放',
  'aria.zoomOut': '缩小画布',
  'aria.zoomIn': '放大画布',
  'aria.controls': '图纸设置',
  'aria.closeControls': '关闭设置',
  'aria.steps': '使用步骤',
  'aria.sizeMode': '尺寸设置方式',
  'aria.presets': '图案最长边快捷尺寸',
  'aria.boardLayout': '底板拼接布局',
  'aria.tools': '绘制工具',
  'aria.stage': '图纸预览与编辑',
  'aria.preview': '预览模式',
  'aria.viewOptions': '视图选项',
  'aria.paletteStats': '色板和用料统计',
  'aria.closePalette': '关闭色板',
  'aria.paletteRange': '色板范围',
  'aria.paletteSeries': '按色系筛选',
  'aria.searchPalette': '搜索色板',
  'aria.projectLicense': '站点信息',
  'aria.mobilePanels': '移动端面板',
  'aria.closeCrop': '关闭裁剪',
  'aria.cropPreview': '图片裁剪预览',
  'aria.closeProduct': '关闭产品说明',
  'aria.printSheet': '打印图纸',
  'aria.printImage': '待打印的拼豆图纸',
  'aria.codesOff': '关闭格内色号',
  'aria.codesOn': '显示格内色号',
  'aria.codesZoom': '色号已开启，请放大后查看',
  'aria.makingProgress': '拼豆制作进度',
  'aria.makingActions': '制作助手操作',
  'aria.previousColor': '上一个颜色',
  'aria.nextColor': '下一个颜色',
  'aria.closeMaking': '关闭制作助手',
  'aria.focusColor': '聚焦 {code}，共 {count} 颗',
  'aria.markColorDone': '将 {code} 标记为完成',
  'aria.markColorUndone': '将 {code} 恢复为未完成',
  'title.undo': '撤销 Ctrl+Z',
  'title.redo': '重做 Ctrl+Y',
  'title.toggleGrid': '显示或隐藏网格',
  'title.toggleRuler': '显示或隐藏坐标标尺',
  'title.toggleCodes': '显示或隐藏格内色号',
  'title.codesToggle': '显示或隐藏格内色号',
  'title.codesZoom': '放大后会在格子里显示色号',
  'title.fitCanvas': '将整张图纸缩放到当前窗口',

  'panel.tools': '工具与设置',
  'panel.image': '图片与转换',
  'panel.localProcessing': '本机处理',
  'dropzone.title': '选择图片 · 智能生成拼豆图',
  'dropzone.note': '会自动识别图片类型并保持比例。动手前记得对照手上的底板和色卡。',
  'smart.kicker': '小白一键模式',
  'smart.calculating': '正在计算推荐方案',
  'smart.defaultSummary': '会自动选择尺寸、处理模式、色板和预览方式。',
  'smart.step1': '1 上传图片',
  'smart.step2': '2 检查图纸',
  'smart.step3': '3 导出制作',
  'smart.generate': '一键智能生成',
  'advice.kicker': '小建议',
  'advice.title': '这张图细节比较多',
  'advice.text': '整张复杂图片无法在当前格数中保留细节。',
  'advice.perBead': '每颗豆对应的范围',
  'advice.expressiveness': '还原程度',
  'advanced.title': '高级设置',
  'advanced.autoConfigured': '一键模式已自动配置',
  'field.processMode': '处理模式',
  'mode.cartoon': '卡通 · 线条清晰',
  'mode.detail': '照片 · 细节丰富',
  'mode.document': '文字与图表 · 保留排版',
  'mode.photo': '照片 · 色彩柔和',
  'mode.pixel': '像素画 · 原样还原',
  'modeHint.cartoon': '适合卡通、线稿和图标：黑色线条和小块亮色会保留得更好。',
  'modeHint.detail': '适合人像、宠物和复杂照片：细节和暗部更清楚。',
  'modeHint.document': '适合论文图、截图和流程图：保留长框线与大色块，主动压制碎文字；不保证正文可读。',
  'modeHint.photo': '适合风景和照片：颜色过渡更柔和。',
  'modeHint.pixel': '适合本来就是像素风的图片：每一格按原样取色。',
  'field.fitMode': '适配方式',
  'fit.cover': '铺满并裁切',
  'fit.contain': '完整显示',
  'field.lightBackground': '去背景',
  'white.auto': '自动去背景',
  'white.smart': '去背景，保留主体白色',
  'white.keep': '不去背景',
  'field.referenceOpacity': '参考底图对照',
  'field.maxColors': '单张图最多用色',
  'field.maxColorsNote': '自动匹配会从当前色板中选择最接近的颜色；这里限制的是本张图实际使用的色数，不是色板总数。',
  'field.mergeStrength': '相近色合并',
  'field.mergeNote': '数值越高，用色越干净；深色轮廓和高饱和强调色会优先保留。',
  'field.protectDark': '黑色更纯正',
  'field.protectDarkNote': '避免黑色被认成深蓝、深棕或紫色。',

  'size.title': '图纸尺寸',
  'size.subtitle': '图案与底板分开',
  'size.patternMode': '按图案清晰度',
  'size.boardMode': '按真实底板',
  'size.patternWidth': '图案宽度',
  'size.patternHeight': '图案高度',
  'size.lockAspect': '锁定原图比例（推荐）',
  'size.aspectInitial': '上传图片后，快捷尺寸表示“图案最长边多少格”，不会强制拉成正方形。',
  'size.longSide': ({ size }) => `长边 ${size}`,
  'board.profile': '实物底板规格',
  'board.mini52': '国内常见 2.6mm · 52×52 格/板',
  'board.mini26': '国内小板 2.6mm · 26×26 格/板',
  'board.artkal50': 'Artkal Mini 2.6mm · 50×50 格/板',
  'board.artkal78': 'Artkal Mini 2.6mm · 78×78 格/板',
  'board.midi29': '5mm 标准 · 29×29 格/板',
  'board.midi14': '5mm 小板 · 14×14 格/板',
  'board.layout.1x1': '1×1 块',
  'board.layout.2x1': '横向 2 块',
  'board.layout.1x2': '竖向 2 块',
  'board.layout.2x2': '2×2 块',
  'board.layout.3x2': '3×2 块',
  'board.layout.2x3': '2×3 块',
  'board.initialTitle': '底板 52×52 · 图案按原比例放入',
  'board.initialText': '上传图片后会显示图案实际占用格数、空白行列、板数与成品尺寸。',
  'board.compatibilityNote': '50 格与 52 格板的针距可能不同，只能按手头实物板型选择；网站不会把不同板型当作可混拼。',

  'tools.title': '绘制与变换',
  'tools.subtitle': '支持拖拽连绘',
  'tool.brush': '画笔 B',
  'tool.eraser': '橡皮 E',
  'tool.picker': '取色 I',
  'tool.mirrorH': '水平镜像',
  'tool.mirrorV': '垂直镜像',
  'tool.rotate': '顺时针 90°',
  'tool.clear': '清空图纸',
  'output.title': '保存与导出',
  'output.subtitle': '图片 · 打印',
  'output.majorGrid': '粗辅助线间隔',
  'output.major5': '每 5 格',
  'output.major10': '每 10 格（推荐）',
  'output.major29': '每 29 格（常见 5mm 方板）',
  'output.majorNote': '粗线方便数格子和拼接底板，预览和下载的图纸都会显示。',

  'preview.square': '色块图纸',
  'preview.bead': '仿真豆粒',
  'view.grid': '网格',
  'view.ruler': '标尺',
  'view.codes': '色号',
  'view.fit': '适合',
  'quality.title': '这张图细节比较多',
  'quality.text': '小字和细线可能看不清',
  'quality.crop': '裁剪一个子图',

  'hero.title': '图片 → 拼豆图纸',
  'hero.text': '放入图片，自动配色、数好豆子，并生成带色号的图纸。',
  'hero.flow1': '放入图片',
  'hero.flow2': '自动转拼豆',
  'hero.flow3': '自动配色',
  'hero.flow4': '统计豆子',
  'hero.flow5': '下载图纸',
  'hero.noInstall': '无需安装',
  'hero.noAccount': '无需注册',
  'hero.noUpload': '图片不上传',
  'hero.offline': '本地完成',
  'hero.local': '图片仅在你的浏览器本地处理',
  'draft.restore': '恢复上次未完成图纸',
  'draft.clear': '清除恢复记录',

  'legend.title': '使用图例',
  'legend.empty': '转换后显示色号与用量',
  'legend.codesZoom': '色号需放大后查看',
  'canvas.help': '方向键移动键盘光标，空格使用当前工具绘制，Delete 删除当前格。',
  'palette.panel': '色板与用料',
  'palette.title': '色板',
  'palette.provider': 'MARD 兼容基础 221 色',
  'palette.countAll': '221 色 · 9 系列',
  'palette.countSeries': '{series} 系 · {count} 色',
  'palette.all': '全部',
  'palette.search': '搜索色号或名称',
  'palette.note': '色板为 MARD 常用 221 色。H1 是透明色，只能手动画入；白色会自动用 H2，黑色用 H7。屏幕上的颜色与实物略有差异，购买前建议对照实物色卡。',
  'palette.transparent': '透明',
  'palette.white': '白色',
  'palette.black': '黑色',
  'palette.series.A': '黄橙系',
  'palette.series.B': '绿色系',
  'palette.series.C': '蓝青系',
  'palette.series.D': '蓝紫系',
  'palette.series.E': '粉玫系',
  'palette.series.F': '红色系',
  'palette.series.G': '棕肤系',
  'palette.series.H': '黑白灰系',
  'palette.series.M': '大地系',
  'stats.title': '用料统计',
  'stats.sorted': '按数量排序',
  'stats.total': '豆子总数',
  'stats.colors': '使用颜色',
  'stats.empty': '空格',
  'stats.emptyList': '上传图片或使用画笔后，这里会实时列出每种颜色的用量。',
  'stats.copyList': '复制购豆清单',
  'stats.listTitle': '拼豆购豆清单（豆趣拼豆）',
  'stats.listMeta': '图纸：{cols} × {rows} 格 · 共 {total} 颗 · {colors} 种颜色',
  'stats.listLine': '{code} {name} · {count} 颗 · 占 {percent}',
  'stats.listTip': '同品牌不同批次可能存在色差，下单前请以实物色卡复核；建议每种颜色多备 10% 左右损耗。',
  'making.kicker': '制作助手',
  'making.title': '按颜色逐步摆豆',
  'making.chooseColor': '从用料清单选择一种颜色',
  'making.progress': '已摆 {done}/{total} 颗 · {colorsDone}/{totalColors} 色 · {percent}%',
  'making.progressAria': '已完成 {percent}%，{colorsDone}/{totalColors} 种颜色',
  'making.focusedCount': '这一色还需核对 {count} 颗',
  'making.allColors': '正在显示全部颜色',
  'making.allColorsDetail': '点用料清单中的颜色可再次聚焦',
  'making.allDone': '全部颜色已完成',
  'making.allDoneDetail': '最后再对照图纸检查一遍吧',
  'csv.code': '色号',
  'csv.name': '颜色名称',
  'csv.hex': '参考颜色',
  'csv.count': '数量',
  'csv.completed': '制作完成',
  'csv.yes': '是',
  'csv.no': '否',

  'status.ready': '准备就绪 · 图片只在本机处理',
  'status.tool.brush': '当前工具：画笔',
  'status.tool.eraser': '当前工具：橡皮',
  'status.tool.picker': '当前工具：取色',
  'footer.privacy': '隐私',
  'footer.terms': '条款',
  'footer.license': '',
  'footer.notices': '',
  'footer.basedOn': '豆趣拼豆 · 图片只在你的浏览器中处理',
  'mobile.tools': '工具',
  'mobile.pattern': '图纸',
  'mobile.palette': '色板',
  'mobile.stats': '用量',

  'crop.title': '裁剪要制作的区域',
  'crop.help': '在图片上拖出想要的区域，或在下方输入百分比。一次只选一个主体，拼出来会更清楚。',
  'crop.precise': '精确裁剪（占原图百分比）',
  'crop.left': '左边距 %',
  'crop.top': '上边距 %',
  'crop.width': '区域宽度 %',
  'crop.height': '区域高度 %',

  'product.title': '使用说明',
  'product.intro': '图片只在你的浏览器里处理，不会上传。',
  'product.stepsTitle': '三步完成',
  'product.step1': '上传图片，优先裁剪单个主体。',
  'product.step2': '看看比例、颜色数和豆子数量是否合适。',
  'product.step3': '下载带色号的图纸；大图可以分页打印。',
  'product.privacyTitle': '隐私',
  'product.privacyText': '原图不会上传。没做完的图纸会暂存在这台设备的浏览器里（不含原图），随时可以清除。',
  'product.colorTitle': '关于颜色',
  'product.colorText': '色板参考 MARD 常用 221 色。屏幕显示与实物会有差异，购买前请对照实物色卡确认。',
  'product.performanceTitle': '底板尺寸',
  'product.performanceText': '不同品牌的底板格数可能不同（如 50 格与 52 格），请按手上的底板选择。图纸格数有限，太小的细节会被简化。',
  'product.repo': '',
  'product.privacy': '隐私说明',
  'product.terms': '使用条款',
  'product.version': '',

  'conversion.title': '正在生成拼豆图纸',
  'conversion.analyzing': '正在分析图片和颜色…',
  'ready.kicker': '图纸已生成',
  'ready.text': '看看图案、色号和豆子数量，没问题就可以下载了。',
  'share.title': '用豆趣拼豆做了一张拼豆图纸',
  'share.text': '用豆趣拼豆做了一张拼豆图纸',
  'share.dialogTitle': '导出分享图',
  'share.dialogHelp': '分享图只用来分享，不会改动你的图纸，也不会上传原图。',
  'share.wide': '16:9 · 横版',
  'share.portrait': '3:4 · 小红书 / 手机',
  'share.download': '下载分享图',
  'share.cardTitle': '图片 → 拼豆图纸',
  'share.cardSubtitle': '图片转拼豆图纸 · 自动配色 · 可打印',
  'share.original': '原图',
  'share.pattern': '拼豆图纸',
  'share.formatLabel': '分享图比例',
  'share.unavailable': '这张图纸没有保存原图，暂时无法生成对比图。',
  'share.copied': '链接已复制',
  'share.failed': '分享不可用，已改为复制链接。',
  'share.cardFooter': '豆趣拼豆',

  'aria.readyActions': '图纸完成操作',
  'aria.communityActions': '更多',
  'aria.closeShare': '关闭宣传图',
  'aria.sharePreview': '宣传图预览',
  'aria.localPromises': '特点',
  'aria.chooseColor': '选择 {code} {name}',
  'aria.copyStats': '把每种颜色的色号、数量与占比复制为纯文本，方便购豆下单',
  'aria.statShare': '占总豆数 {percent}',
  'aria.patternCanvas': '{cols} 列 × {rows} 行拼豆图纸。方向键移动，空格绘制，Delete 擦除。',
  'title.color': '{code} {name} {hex}',
  'title.zoomLimit': '当前图纸最高缩放 {percent}%',

  'size.patternAndBoard': '图案 {patternCols}×{patternRows} / 底板 {boardCols}×{boardRows}',
  'size.patternOnly': '图案 {cols}×{rows}',
  'size.boardCols': '底板总列数',
  'size.boardRows': '底板总行数',
  'size.aspectUnlockedInitial': '未锁定；上传后可独立设置宽高。',
  'size.aspectLocked': '已按原图 {ratio}:1 锁定；快捷尺寸会自动得到 {cols}×{rows} 一类的比例。',
  'size.aspectUnlocked': '已关闭比例锁定；“完整显示”会留白，“铺满并裁切”会裁掉内容。',
  'board.statusTitle': '底板 {boardCols}×{boardRows} · 图案 {patternCols}×{patternRows}（不拉伸）',
  'board.statusBody': '{profile} × {count} 块；约 {width}×{height}cm。图案居中，左/右空 {left}/{right} 列，上/下空 {top}/{bottom} 行，共 {blank} 个空位。',

  'punctuation.list': '，',
  'quality.textTooSmall': '文字低于可制作尺寸',
  'quality.aspectMismatch': '图案比例不一致',
  'quality.detailConflict': '有细节超出当前格位',
  'quality.outlineOnly': '当前只能保留轮廓',
  'quality.structureOnlyShort': '{size} 只能保留大致轮廓，{action}',
  'quality.cropSuggestion': '建议先缩小范围',
  'quality.modeOrCropSuggestion': '请切换文档模式或先裁剪',
  'quality.aspectShort': '{cols}×{rows} 与原图比例不一致；{result}',
  'quality.hasMargins': '当前存在明显留白',
  'quality.cropsContent': '当前会裁掉部分内容',
  'quality.detailShort': '{size}：{warning}，系统未强行多放豆',
  'quality.outlineShort': '{size} 只能保留主体轮廓和大色块，更细的部分会被简化',
  'quality.documentWarning': '图里文字比较多',
  'quality.aspectWarning': '比例与裁切警告',
  'quality.cellConflict': '格位冲突提示',
  'quality.smallWarning': '小尺寸清晰度警告',
  'quality.documentTitle': '整图超出 100 格的可读范围',
  'quality.aspectTitle': '{cols}×{rows} 不是原图比例',
  'quality.photoDetailTitle': '当前格数不足以表达照片细节',
  'quality.documentBody': '当前 {size} 只能保留版面、长框线和大色块，正文不会成为可读文字。{modeAdvice}按 {beadMm}mm 豆约 {width}×{height}cm；裁剪单个子图最有效。',
  'quality.documentModeAdvice': '可以试试“文字与图表”模式，',
  'quality.letterboxBody': '原图没有被拉伸，但约 {percent}% 的图纸是空白，真正有图案的区域只有约 {cols}×{rows} 格。可以换成和图片比例一致的尺寸。',
  'quality.cropBody': '为铺满当前图纸会裁掉约 {percent}% 的原图范围；主体靠近边缘时会直接消失。可改用原图比例，或先手动裁剪主体。',
  'quality.detailBody': '{warning}。建议提高到下一档尺寸，或放大后用画笔补画。',
  'quality.photoBody': '当前长边约 {long} 格，照片里的小字和细线会看不清。调大尺寸或先裁剪会更清楚。',
  'quality.sourcePixels': '原图 {x}×{y}',
  'quality.glyphHeight': '正文约 {height} 格高',
  'quality.largeStructureOnly': '只能保留大致轮廓',
  'quality.marginPercent': '留白 {percent}%',
  'quality.cropPercent': '裁切 {percent}%',
  'quality.pixelsPerBead': '每颗豆约对应 {count} 个点',
  'quality.alreadySize': '已是 {cols}×{rows}',
  'quality.fixAspect': '按原比例修正为 {cols}×{rows}',
  'quality.increaseSize': '提高到 {cols}×{rows} · 按 {beadMm}mm 豆约 {width}×{height}cm',
  'quality.cropChoose': '裁剪并选择主体',
  'quality.oneSubject': '只制作一个主体',
  'quality.fixAspectShort': '按原比例修正',
  'quality.cropSubject': '裁剪主体',
  'quality.missingDetails': '{count} 个细节小于一格',
  'quality.detailCollisions': '{count} 处细节无法安全分开',
  'quality.detailIntegrity': '{details}；系统没有强行多放豆或把独立线条粘在一起',
  'quality.marginVerb': '留白',
  'quality.cropVerb': '裁切',

  'smart.documentUnreadable': '整页文字无法变成可读拼豆图',
  'smart.documentSummary': '最多 {cols}×{rows} 只能保留大致排版；建议先裁剪出想做的部分。',
  'smart.cropFirst': '先裁剪一个区域',
  'smart.generatedWithWarning': '已生成，但{warning}',
  'smart.generatedSmallLine': '已生成小尺寸线稿精修图',
  'smart.generatedReview': '已生成，请核对后导出',
  'smart.trimmed': '已安全去除外围纯白空白约 {percent}%，可随时恢复完整原图。',
  'smart.detailWarning': '{warning}；建议升到 {size} 格或用画笔补。',
  'smart.readySummary': '{size} · {beads} 颗豆 · {colors} 色 · 原图比例未拉伸。{framing}{detailWarning} 按 {beadMm}mm 豆约 {width}×{height}cm。用料总数严格等于所有非空格；制作前请核对实物色卡。',
  'smart.regenerate': '重新智能生成',
  'smart.customTooSmall': '自定义尺寸过小，只能保留大轮廓',
  'smart.customAspect': '自定义尺寸与原图比例不一致',
  'smart.custom': '当前使用自定义设置',
  'smart.customIssues': '当前 {cols}×{rows}：{warning}。建议提高到下一档尺寸，或放大后用画笔补画。',
  'smart.customCapacity': '当前 {cols}×{rows} 只有约 {cells} 个有效格，细节丢失无法靠锐化恢复；建议提高尺寸或裁剪主体。',
  'smart.customMismatch': '当前会{effect}约 {percent}%；建议使用下方“按原比例修正”。',
  'smart.customSummary': '当前 {cols}×{rows}、最多 {colors} 色；可随时恢复智能生成方案。',
  'smart.restore': '恢复智能生成方案',
  'smart.recommendedReady': '已准备推荐方案',
  'smart.trimmedShort': '已去除外围纯白空白约 {percent}% · ',
  'smart.recommendedSummary': '{cols}×{rows} · 最多 {colors} 色 · {trimmed}MARD 221 色',

  'unit.beads': '{formatted} 颗豆',
  'unit.colors': '{count} 种颜色',
  'unit.colorsValue': '{count} 色',
  'history.undoAvailable': '{label} · 可撤销 {count} 步',
  'history.edited': '已编辑图纸',
  'history.stroke': '已完成一笔绘制',
  'history.converted': '已转换图片',
  'file.details': '{width} × {height} · {size} MB{suffix}',
  'file.trimmed': ' · 已自动紧贴主体',
  'file.cropped': '已裁剪 · {width}×{height}',
  'file.restored': '已恢复完整原图边界',
  'crop.sourcePixels': '{width} × {height}',
  'conversion.progress': '{mode}处理中 · 最多 {colors} 色…',
  'conversion.backgroundRemoved': '，边界背景已留空',
  'conversion.colorsMerged': '，已从 {before} 种整理为 {after} 种',

  'status.generatingPixel': '正在生成 {cols}×{rows} 图纸…',
  'status.conversionBlocked': '转换处理中 · 已阻止会破坏图纸状态的操作',
  'status.undo': '已撤销上一步操作',
  'status.redo': '已重做一步操作',
  'status.loadingSample': '正在载入图片…',
  'status.sampleFailed': '图片载入失败',
  'status.readingImage': '正在读取图片…',
  'status.imageReadFailed': '图片读取失败',
  'status.conversionComplete': '转换完成 · {mode} · {size} · {colors} 种颜色',
  'status.documentPreview': '{kind} · {size} · 小字会看不清 · {advice}',
  'status.structurePreview': '排版预览',
  'status.complexPreview': '文字较多',
  'status.cropSuggested': '建议先裁剪想做的部分',
  'status.modeSuggested': '建议先裁剪想做的部分',
  'status.smallRefine': '小尺寸精修完成 · {warning} · 建议提高格数',
  'status.conversionFailed': '{reason} · 已恢复上一张完整图纸',
  'status.timeout': '转换超时',
  'status.browserUnsupported': '当前浏览器无法启动安全的后台转换',
  'status.failed': '转换失败',
  'status.boardPattern': '图案{patternCols}×{patternRows}/底板{boardCols}×{boardRows}',
  'status.zoom': '{message} · 缩放 {percent}%',
  'status.zoomValue': '缩放 {percent}%',

  'toast.chooseImageFirst': '请先选择一张图片。',
  'toast.colorSelected': '已选择 {code} {name}',
  'toast.conversionBusy': '图片正在转换，请等待完成或先点“取消处理”。',
  'toast.sampleFailed': '图片载入失败，请改为选择本地图片。',
  'toast.imageTooLarge': '图片超过 24MB，请先压缩后再试。',
  'toast.invalidImage': '这张图片打不开，换一张 JPG 或 PNG 试试。',
  'toast.imagePixelsTooLarge': '图片太大了，先缩小一些再试试。',
  'toast.safeDecodeFailed': '当前浏览器无法安全缩放解码这张大图，请先压缩图片后再试。',
  'toast.imageDamaged': '这张图片打不开，换一张 JPG 或 PNG 试试。',
  'toast.photoModeAuto': '识别到这是一张照片，已切换为照片模式。',
  'toast.documentPreview': '已生成排版预览，小字会看不清。',
  'toast.documentDetected': '图里文字比较多，建议只裁剪想做的部分。',
  'toast.conversionTimeout': '转换耗时过长，已取消并恢复上一张完整图纸。请改用高清照片模式或缩小图片。',
  'toast.workerUnsupported': '当前浏览器不支持安全的后台转换。请使用最新版 Chrome、Edge、Firefox 或 Safari。',
  'toast.conversionFailed': '转换失败，已恢复上一张完整图纸。',
  'toast.conversionComplete': '转换完成：使用 {colors} 种颜色{background}{merged}',
  'toast.generatedWarning': '已生成，但{warning}；建议提高尺寸或用画笔补。',
  'toast.cropTooSmall': '裁剪区域太小，请放大选择范围。',
  'toast.emptyPicker': '空格没有色号，请选择有颜色的格子。',
  'toast.boardTooLarge': '这个拼接布局超过 160 格上限，请减少横向或纵向底板数量。',
  'toast.zoomLimit': '当前 {cols}×{rows} 图纸为控制内存，最高缩放 {percent}%。',
  'toast.canvasOverview': '已显示完整图纸；当前为全图预览，放大后再编辑。',
  'toast.canvasFit': '已缩放到 {percent}%',
  'toast.exportDone': '图纸已下载',
  'toast.exportMemory': '当前设备无法安全生成这么大的单张图，请降低尺寸或改用分页打印。',
  'toast.exportFailed': '导出失败，请降低图纸尺寸后重试。',
  'toast.draftStorage': '浏览器本地恢复空间不足；请手动保存可编辑图纸。',
  'toast.draftCleared': '本机恢复记录已清除',
  'toast.statsCopied': '购豆清单已复制，可粘贴到备忘或直接发给商家',
  'toast.statsCopyFailed': '复制失败，请对照右侧用量统计手动记录。',
  'toast.draftInvalid': '恢复记录无效或已损坏，已安全清除。',
  'toast.projectSaved': '可编辑图纸已写入所选文件；参考原图未包含。',
  'toast.projectDownloadStarted': '图纸文件开始下载了（不含原图）。',
  'toast.projectRestored': '已恢复上次未完成图纸；参考原图未包含，请继续编辑或保存。',
  'toast.projectMigrated': '旧图纸的颜色已自动换成现在的 221 色。',
  'toast.projectLoaded': '图纸已打开',
  'toast.projectTooLarge': '文件太大或是空的。',
  'toast.projectInvalid': '打不开这个文件，请确认是本站保存的图纸。',
  'toast.printFailed': '打印预览没能生成，可以调小尺寸或直接下载图纸。',
  'toast.boardContainOnly': '真实底板模式固定“完整保留”：图案按原比例居中放入底板，不允许静默裁切或拉伸。',
  'toast.codesNeedZoom': '放大后可以看清每格的色号，下载的图纸会完整标注。',
  'toast.previewEditZoom': '当前为全图预览；请先放大到可编辑比例。',
  'toast.conversionCanceled': '本次转换已取消，原图纸未丢失',
  'toast.noMaterials': '当前图纸还没有可制作的豆子。',
  'toast.makingStarted': '制作助手已开启；画布会突出当前色号。',
  'toast.colorDone': '{code} 已标记完成，已切换到下一种颜色。',
  'toast.colorUndone': '{code} 已恢复为未完成。',
  'toast.makingReset': '制作进度已重置。',
  'toast.csvExported': '材料表已导出：{colors} 色，{beads} 颗。',

  'status.boardSwitched': '已切换真实底板规格',
  'status.sizeCleared': '已更改图纸尺寸并清空画布',
  'status.rotated': '已顺时针旋转 90°',
  'status.mirroredH': '已水平镜像',
  'status.mirroredV': '已垂直镜像',
  'status.cleared': '已清空图纸',
  'status.canvasOverview': '全图预览 · 放大后编辑',
  'status.canvasFit': '画布已适合窗口',
  'status.exporting': '正在准备高清图纸…',
  'status.exportDone': '图纸下载完成',
  'status.exportFailed': '图纸下载失败',
  'status.draftCleared': '本机恢复记录已清除',
  'status.projectSaved': '图纸已保存',
  'status.projectDownloadStarted': '图纸开始下载',
  'status.projectRestored': '已恢复 {cols}×{rows} 未完成图纸',
  'status.projectLoaded': '已打开 {cols}×{rows} 图纸{migration}',
  'status.projectMigration': ' · 已迁移至基础 221 色号',
  'status.projectLoadFailed': '图纸打开失败',
  'status.printReady': '已生成 {count} 页打印预览 · 打印时请勿启用“适合单页”二次缩放',
  'status.printFailed': '打印预览生成失败',
  'status.conversionCanceled': '已取消转换，已恢复上一张完整图纸',
  'status.majorGrid': '粗辅助线已设为每 {count} 格',
  'status.makingStarted': '制作助手已开启 · 逐色核对并记录进度',
  'status.makingStopped': '已退出制作模式，进度会保留',
  'status.csvExported': '购豆清单已导出 · {colors} 色 · {beads} 颗',

  'history.boardChanged': '已切换真实底板规格',
  'history.sizeCleared': '已更改图纸尺寸并清空画布',
  'history.rotated': '已顺时针旋转 90°',
  'history.mirroredH': '已水平镜像',
  'history.mirroredV': '已垂直镜像',
  'history.cleared': '已清空图纸',
  'history.keyboardDraw': '已使用键盘绘制',
  'history.keyboardErase': '已使用键盘擦除',

  'confirm.boardQualitySevere': '\n\n清晰度警告：这块板只能保留主体轮廓和大色块；照片文字与细节不会可读。',
  'confirm.boardQualityLow': '\n\n清晰度提示：单板适合一般卡通；复杂照片建议改用 104 格或更大布局。',
  'confirm.boardSwitch': '切换为 {profile}、{tilesX}×{tilesY} 块，将生成“图案 {patternCols}×{patternRows} / 底板 {boardCols}×{boardRows}”。这会丢弃当前手工修改，成功后可撤销。{quality}\n\n是否继续？',
  'confirm.patternMode': '切换为按图案清晰度，将从底板中取出 {cols}×{rows} 图案并重新生成；当前手工修改会被替换，成功后可撤销。是否继续？',
  'confirm.resizeQuality': '\n\n清晰度警告：该尺寸只有约 {cells} 个有效格，只能保留主体轮廓和大色块，照片文字与细节必然消失。',
  'confirm.resize': '改为 {cols}×{rows} 会丢弃当前手工修改，并按原图重新生成。生成成功后可撤销回当前完整图纸。{quality}\n\n是否继续？',
  'confirm.clear': '确定清空当前图纸吗？此操作可以撤销。',
  'confirm.resetMaking': '确定清空所有逐色制作进度吗？图纸本身不会改变。',
  'confirm.exportIssues': '当前图纸{issues}。建议先提高尺寸或用画笔补画；仍要导出吗？',
  'confirm.loadProject': '当前图纸有未保存修改。继续读取会覆盖当前工作；选择“取消”后可先保存可编辑图纸。\n\n确定放弃修改并继续吗？',
  'confirm.printPages': '当前 {cols}×{rows} 图纸将按最多 {span}×{span} 格分页，共 {pages} 页。每页保留全局坐标、逐格色号、辅助线与本页用料；是否继续？',
  'confirm.clearDraft': '只会清除本浏览器中的自动恢复记录，不会删除已经下载的文件。确定清除吗？',
  'confirm.coverCrop': '铺满当前画布会裁掉约 {percent}% 的原图范围。继续前请确认主体不在边缘；是否仍要裁切铺满？',

  'prompt.projectName': '给图纸起个名字吧（会写进文件里）',
  'project.defaultName': '我的拼豆图纸',
  'project.importedName': '导入图纸',
  'project.loadedSubtitle': '已打开保存的图纸 · 不含原图',
  'project.fileDescription': '豆趣拼豆可编辑图纸',
  'project.recoveryFile': '自动恢复.bead.json',
  'file.patternFallback': '拼豆图纸',

  'export.header': '{title} · {cols}列 × {rows}行 · {colors}色 · 共{beads}颗',
  'export.boardCopy': '{profile} × {tilesX}×{tilesY}块 · 图案{cols}×{rows}',
  'export.patternCopy': '按原图比例的图案尺寸',
  'export.subtitle': 'MARD 兼容基础 221 色号 · {board} · 每 {step} 格辅助线 · 逐格色号',
  'export.materials': '用料清单',
  'export.count': '{count} 颗',
  'export.total': '所需豆子总数：{count} 颗',
  'export.boardSize': '图案 {patternCols}×{patternRows} · 底板 {boardCols}×{boardRows} · {boards}块',
  'export.patternSize': '{cols} 列 × {rows} 行',
  'export.sizeSummary': '图纸尺寸：{size} · 辅助线每 {step} 格',
  'export.generated': '豆趣拼豆 · 本机生成',
  'print.pageTitle': '{title} · 第 {page}/{pages} 页',
  'print.pageSubtitle': '全图 {cols}×{rows} · 本页列 {startCol}–{endCol} / 行 {startRow}–{endRow} · 色号按兼容基础 221 色',
  'print.materials': '本页用料',
  'print.count': '{code} · {count}颗',
  'confirm.replaceImage': '当前图纸有未保存修改。继续上传会覆盖当前工作；选择“取消”后可先保存可编辑图纸。\n\n确定放弃修改并继续吗？',
};

export default zhCN;
